import { css } from 'styled-components';

import { typographyBody1 } from './../../core';

export const tablePaginationTextStyles = css`
  ${({ theme }) => typographyBody1(theme)};
  color: ${({ theme }) => theme.color.text.light.secondary.value};
`;
